export default __webpack_public_path__ + "static/media/service_3.01d6d6b2.png";